import { Link } from "react-router";
import { Mail } from "lucide-react";
import { NewsletterForm } from "../components/NewsletterForm";

// Columns, legal links and copy are shared with the server-rendered blog
// footer (packages/blog-engine) via @weconsultrx/site-chrome.
import {
  FOOTER_COLUMNS as COLS,
  FOOTER_LEGAL_LINKS,
  FOOTER_TAGLINE,
  CONTACT_EMAIL,
  COPYRIGHT_HOLDER,
} from "@weconsultrx/site-chrome";

export function Footer() {
  return (
    <footer className="bg-ink-900 text-ink-200 mt-24">
      <div className="mx-auto max-w-container px-6 md:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_3fr]">
          {/* Brand block */}
          <div>
            <Link to="/" aria-label="WeConsult Rx home" className="inline-flex">
              <img
                src="/logo-stacked-on-dark.svg"
                alt="WeConsult Rx"
                width="220"
                height="154"
                className="h-32 w-auto"
              />
            </Link>
            <p className="mt-4 text-sm text-ink-300 max-w-xs">
              {FOOTER_TAGLINE}
            </p>
            <div className="mt-6">
              <p className="text-xs uppercase tracking-tagline font-semibold text-forest-400">
                Newsletter
              </p>
              <p className="mt-2 text-sm text-ink-300">
                Quarterly product updates. No spam.
              </p>
              <NewsletterForm className="mt-3" />
            </div>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <p className="text-xs uppercase tracking-tagline font-semibold text-forest-400">
                  {col.title}
                </p>
                <ul className="mt-3 space-y-2">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.to ? (
                        <Link to={l.to} className="text-sm text-ink-300 hover:text-white">
                          {l.label}
                        </Link>
                      ) : (
                        <a
                          href={l.href}
                          className="text-sm text-ink-300 hover:text-white"
                        >
                          {l.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-ink-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-ink-400">
            &copy; {new Date().getFullYear()} {COPYRIGHT_HOLDER}
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink-400">
            <a className="inline-flex items-center gap-1 hover:text-white" href={`mailto:${CONTACT_EMAIL}`}>
              <Mail className="h-3.5 w-3.5" /> {CONTACT_EMAIL}
            </a>
            {FOOTER_LEGAL_LINKS.map((l) => (
              <Link key={l.label} to={l.to!} className="hover:text-white">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
